{
  "overview.title": "Overview",
  "overview.body": "How the day looks at {workshop}.",
  "overview.kpi.today": "Jobs today",
  "overview.kpi.today_hint": "Midnight to midnight, cancellations excluded.",
  "overview.kpi.week": "Next seven days",
  "overview.kpi.week_hint": "Everything booked ahead.",
  "overview.kpi.pending": "Awaiting an answer",
  "overview.kpi.pending_hint": "Bookings that need a decision from you.",
  "overview.kpi.value": "Value today",
  "overview.kpi.value_hint": "Total for today's jobs.",
  "overview.today.heading": "Today's jobs",
  "overview.today.empty": "No bookings today.",
  "overview.column.time": "Time",
  "overview.column.customer": "Customer",
  "overview.column.service": "Service",
  "overview.column.resource": "Resource",
  "overview.column.status": "Status",
  "overview.column.value": "Value",
  "overview.unassigned": "Nobody assigned",
  "overview.open_calendar": "Open the calendar",
  "overview.error": "We could not load the overview.",
  "calendar.title": "Calendar",
  "calendar.today": "Today",
  "calendar.previous": "Previous",
  "calendar.next": "Next",
  "calendar.view.day": "Day",
  "calendar.view.week": "Week",
  "calendar.view.month": "Month",
  "calendar.new_booking": "New booking",
  "calendar.create.walkin": "Walk-in",
  "calendar.create.walkin.hint": "The customer is in the workshop. The booking is confirmed straight away.",
  "calendar.create.service": "Service",
  "calendar.create.service.empty": "No services have been set up yet.",
  "calendar.create.when": "Time",
  "calendar.create.date": "Date",
  "calendar.create.resource": "Carried out by",
  "calendar.create.resource.auto": "Choose for me",
  "calendar.create.customer": "Customer",
  "calendar.create.name": "Name",
  "calendar.create.email": "Email",
  "calendar.create.email.hint": "The confirmation goes here. Without email, a phone number is required.",
  "calendar.create.phone": "Phone",
  "calendar.create.submit": "Create booking",
  "calendar.create.saving": "Creating …",
  "calendar.create.created": "The booking has been created.",
  "calendar.create.error.service": "Choose at least one service.",
  "calendar.create.error.name": "Enter the customer's name.",
  "calendar.create.error.email": "Check the email address.",
  "calendar.create.error.contact": "We need either an email address or a phone number.",
  "calendar.create.slots": "Available times",
  "calendar.create.slots.hint": "Choose a service to see available times.",
  "calendar.create.slots.empty": "No times available on this day.",
  "calendar.create.slots.nearest": "Nearest available times",
  "calendar.create.slots.taken": "That time is taken. Choose one of the times below.",
  "calendar.create.slots.none": "Fully booked for the next {days} days.",
  "calendar.create.slots.error": "Could not load available times.",
  "calendar.create.slots.pick": "Choose {time}",
  "calendar.create_in_column": "New booking for {resource}",
  "calendar.filter": "Filter",
  "calendar.filter.clear": "Clear filters",
  "calendar.filter.resource": "Resource",
  "calendar.filter.service": "Service",
  "calendar.filter.status": "Status",
  "calendar.filter.all": "All",
  "calendar.zoom": "Row height",
  "calendar.now": "Now",
  "calendar.week_of": "Week {week}",
  "calendar.status.pending": "Not confirmed",
  "calendar.status.confirmed": "Confirmed",
  "calendar.status.in_progress": "In progress",
  "calendar.status.completed": "Done",
  "calendar.status.cancelled": "Cancelled",
  "calendar.status.no_show": "No show",
  "calendar.status.external": "From Google",
  "calendar.resource.staff": "Technician",
  "calendar.resource.van": "Mobile unit",
  "calendar.resource.bay": "Bay",
  "calendar.blocker.vacation": "Holiday",
  "calendar.blocker.sick": "Sick",
  "calendar.blocker.training": "Training",
  "calendar.blocker.break": "Break",
  "calendar.blocker.closed": "Closed",
  "calendar.blocker.blackout": "Blocked",
  "calendar.blocker.add": "Block time",
  "calendar.blocker.kind": "Reason",
  "calendar.blocker.whole_day": "All day",
  "calendar.blocker.repeat": "Repeat weekly",
  "calendar.blocker.repeat_until": "Until",
  "calendar.blocker.save": "Save block",
  "calendar.blocker.remove": "Remove block",
  "calendar.blocker.synced": "This comes from Google and cannot be changed here.",
  "calendar.event.label": "{service}, {time}, {resource}, {status}",
  "calendar.event.buffer": "Preparation time",
  "calendar.drag.moved": "Moved to {time}, {resource}",
  "calendar.drag.saved": "Saved: {time}, {resource}",
  "calendar.drag.cancelled": "Move cancelled",
  "calendar.drag.hint": "Space to pick up, arrow keys to choose a time, Enter to save.",
  "calendar.empty.day": "No bookings today. Would you like to add one?",
  "calendar.empty.filtered": "No bookings match the filter.",
  "calendar.empty.no_resources": "This workshop has no resources yet.",
  "calendar.error.load": "We could not load the calendar.",
  "calendar.error.retry": "Try again",
  "calendar.offline": "You are offline. The calendar shows how it last looked.",
  "calendar.stale.one": "{count} new booking — refresh",
  "calendar.stale.other": "{count} new bookings — refresh",
  "calendar.conflict.title": "That time has just been taken",
  "calendar.conflict.alternatives": "Here are three other times:",
  "calendar.conflict.reverted": "The booking is still at its original time.",
  "calendar.unassigned.title": "Unassigned",
  "calendar.unassigned.empty": "Every booking has a resource.",
  "calendar.unassigned.hint": "Drag a booking onto a column to assign it.",
  "calendar.unassigned.assign": "Assign to {resource}",
  "route.title": "Today's route",
  "route.empty": "No stops today.",
  "route.stop": "Stop {index}",
  "route.travel_from_previous": "{minutes} min drive ({km} km)",
  "route.travel_from_base": "{minutes} min from the workshop ({km} km)",
  "route.no_address": "No address given",
  "route.estimate_note": "Travel times are straight-line estimates.",
  "job.title": "Job card",
  "job.customer": "Customer",
  "job.object": "Object",
  "job.services": "Services",
  "job.status": "Status",
  "job.notes": "Internal notes",
  "job.notes.placeholder": "Only visible to the workshop.",
  "job.notes.save": "Save note",
  "job.notes.saved": "Note saved",
  "job.photos": "Photos",
  "job.photos.before": "Before",
  "job.photos.after": "After",
  "job.photos.damage": "Damage",
  "job.photos.add": "Add photo",
  "job.photos.empty": "No photos yet.",
  "job.photos.uploading": "Uploading …",
  "job.photos.remove": "Remove photo",
  "job.photos.too_large": "That photo is too large. Max {mb} MB.",
  "job.photos.wrong_type": "That does not look like an image.",
  "job.notifications": "Notifications",
  "job.notifications.empty": "Nothing has been sent for this booking.",
  "job.total": "Total",
  "job.booked_at": "Booked {when}",
  "job.source.web": "Booked online",
  "job.source.phone": "Booked by phone",
  "job.source.walkin": "Walk-in",
  "job.source.partner": "Booked by a partner",
  "job.source.import": "Imported booking",
  "job.cancel": "Cancel booking",
  "job.cancel.reason": "Reason",
  "job.cancel.confirm": "Cancel this booking",
  "job.cancel.warning": "The customer will be emailed that the booking is cancelled.",
  "calendar.create.drop_off": "Drop-off",
  "calendar.create.ready": "Ready",
  "calendar.create.ready_invalid": "Ready must be at least 5 minutes after drop-off.",
  "job.times": "Time and price",
  "job.times.save": "Save",
  "job.times.saved": "Saved",
  "job.price": "Price ({currency})"
}
